import React, { useState } from "react";
import Select from "react-select";
import {
  Row,
  Col,
  Card,
  Tooltip,
  OverlayTrigger,
  Table,
} from "react-bootstrap";
import { FaCalculator } from "react-icons/fa";
import {
  BsFileEarmarkText,
  BsCreditCard,
  BsGraphUp,
  BsExclamationTriangle,
} from "react-icons/bs";
import * as Yup from "yup";
import { ComingSoonWrapper } from "./Payments";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import { useSelector } from "react-redux";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import BorrowerViewStatement from "../../LoanDetails/BorrowerViewStatement";
import FormBox from "../../../components/FormBox/FormBox";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { LoadingButton } from "../../../Utils/CustomComponent";
import axios from "../../../axios";
import urls from "../../../Utils/urls";
import CommonGrid from "../../../components/CommonGrid";
import { gridColumns_PayoffCalculator } from "../../../Utils/TableColumnDefs";
import { useNavigate } from "react-router-dom";
import NumberFormat from "react-number-format";
import InterestCalculator from "./InterestCalculator";
import "./style.css";

function QuickAccess() {
  const [viewStatementShow, setViewStatementShow] = useState(false);
  const [showPayOffCalculator, setShowPayOffCalculator] = useState(false);
  const [showInterestCalc, setShowInterestCalc] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Card className="p-4 border-primary h-100 quickAccess">
        <h5 className="mb-4 px-3">Quick Access</h5>
        <Row className="text-center g-4">
          {[
            {
              icon: BsFileEarmarkText,
              label: "View Statement",
              onClick: () => setViewStatementShow((prev) => !prev),
              tooltip: "View your latest and past account statements.",
            },
            // { icon: BsCreditCard, label: "Same Day Payment" },
            {
              icon: BsGraphUp,
              label: "Reports",
              condition: true,
              // onClick: () => navigate("/reports-and-documents"),
              tooltip: "",
            },
            {
              icon: FaCalculator,
              label: "Interest Calculator",
              condition: false,
              onClick: () => setShowInterestCalc((prev) => !prev),
              tooltip: "Estimate interest based on principal, rate, and time.",
            },
            // {
            //   icon: FaCalculator,
            //   label: "Payoff Calculator",
            //   condition: false,
            //   onClick: () => setShowPayOffCalculator((prev) => !prev),
            //   tooltip:
            //     "Calculate the estimated payoff amount for your loan, including any outstanding fees.",
            // },
            {
              icon: BsExclamationTriangle,
              label: "NSF History",
              onClick: () => navigate("/nsf-history"),
              tooltip:
                "View your Non-Sufficient Funds (NSF) history and payment failures.",
            },
          ].map((item, index) => (
            <Col
              key={index}
              xs={4}
              className="d-flex flex-column align-items-center "
            >
              <ComingSoonWrapper
                condition={item.condition}
                label={item.label}
                tooltip={item.tooltip}
              >
                <div
                  className="d-flex justify-content-center align-items-center bg-light rounded-circle hover-effect"
                  role="button"
                  style={{
                    width: "70px",
                    height: "70px",
                    padding: "10px",
                  }}
                  onClick={item?.onClick && item.onClick}
                  // title={item.tooltip}
                >
                  <item.icon
                    size={35}
                    className={!item?.condition ? "text-primary" : "text-light"}
                  />
                </div>
              </ComingSoonWrapper>
              <p className="small mt-2" title={item.label}>
                {item.label}
              </p>
            </Col>
          ))}
        </Row>
        <ViewSatementModal
          show={viewStatementShow}
          setShow={setViewStatementShow}
        />
        <PayOffCalculator
          show={showPayOffCalculator}
          setShow={setShowPayOffCalculator}
        />
        <InterestCalculator
          show={showInterestCalc}
          setShow={setShowInterestCalc}
        />
      </Card>
    </>
  );
}

export default QuickAccess;

const ViewSatementModal = ({ show, setShow }) => {
  const [account, setAccount] = useState(null);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const { activeAccountList, accountsLength } = useBorrowerDashboardTwo();

  function handleAccountChange(e) {
    setAccount(e);
  }

  return (
    <div>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            {accountsLength ? (
              <div>
                <Select
                  options={activeAccountList}
                  value={account ? account : null}
                  onChange={handleAccountChange}
                  classNamePrefix="select"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                      ...theme.colors,
                      primary: "#ef8860",
                    },
                  })}
                />
                <BorrowerViewStatement loanID={account?.value} />
              </div>
            ) : (
              <div className="fs-5">No active loans</div>
            )}
          </ErrorBoundary>
        }
        title="View Statement"
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
          setAccount(null);
        }}
      />
    </div>
  );
};

const PayOffCalculator = ({ show, setShow }) => {
  const [data, setData] = useState([]);
  const [dataObj, setDataObj] = useState(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const { activeAccountList, accountsLength } = useBorrowerDashboardTwo();
  const options =
    activeAccountList?.map((el) => ({
      label: el.displayValue,
      value: el.value,
    })) || [];

  const createPayoffFormSchema = {
    resolver: yupResolver(
      Yup.object().shape({
        loanrecid: Yup.string().required("Loan number is required!"),
        payoff_good_through_date: Yup.string().required(
          "Payoff Good Through Date is required!"
        ),
      })
    ),
  };
  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm(createPayoffFormSchema);

  async function onSubmit(data) {
    setDisableBtn(true);
    try {
      const header = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          payoff_good_through_date: data.PAYOFF_GOOD_THROUGH_DATE,
        },
      };
      const res = await axios.get(
        urls.borrower.borrowerPayoffCalculator(data.loanrecid),
        header
      );

      const resData = res?.data?.items;

      setDataObj(resData[0]);
      setData(resData);
    } catch (error) {
      console.error(error);
    } finally {
      setDisableBtn(false);
    }
  }

  return (
    <div>
      <PopupWrapper
        extraClass="width-800"
        Component={
          <ErrorBoundary>
            {accountsLength ? (
              <div>
                <FormBox
                  options={payOffArr(options, data)}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  errors={errors}
                />
                {data?.length ? (
                  <div>
                    <h4>Calculation results: </h4>
                    {/* <CommonGrid
                      title="Payoff Calculation"
                      gridColumns={gridColumns_PayoffCalculator}
                      columnData={data}
                      minHeight={""}
                      tHeight={"10vh"}
                      viewAllModal={true}
                      footer={false}
                    /> */}
                    <Table bordered size="lg" style={{ fontSize: "16px" }}>
                      <tbody>
                        {resultArr.map((item) =>
                          Object.keys(dataObj)
                            ?.filter((el) => el === item.field)
                            ?.map((item1) => (
                              <tr key={item1}>
                                <th
                                  style={{ background: "rgb(251, 251, 251)" }}
                                  className="text-primary"
                                >
                                  {item.title}
                                </th>
                                <td className="text-muted">
                                  {" "}
                                  <NumberFormat
                                    displayType="text"
                                    value={dataObj[item1]}
                                    prefix={"$"}
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    thousandSeparator={true}
                                  />
                                </td>
                              </tr>
                            ))
                        )}
                      </tbody>
                    </Table>
                    {/* {resultArr.map((item) =>
                      Object.keys(dataObj)
                        ?.filter((el) => el === item.field)
                        ?.map((item1) => (
                          <div className="d-flex gap-5">
                            <dt className="text-primary">{item.title}:</dt>
                            <dd className="text-muted">
                              {formatNumbers(dataObj[item1])}
                            </dd>
                          </div>
                        ))
                    )} */}
                    <p className="mt-5 border p-3">
                      <b>Disclaimer:</b> The payoff amount shown is an estimate
                      and may change due to interest, fees, or other charges.
                      For the exact amount, please request an official payoff
                      statement. Superior Loan Servicing is not liable for any
                      discrepancies or losses based on this estimate.
                    </p>
                  </div>
                ) : (
                  <div>
                    <LoadingButton
                      type="button"
                      className="btn btn-primary mt-3 text-white"
                      onClick={handleSubmit(onSubmit)}
                      title={"Calculate Payoff"}
                      disabled={disableBtn}
                      loading={disableBtn}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="fs-5">No active loans</div>
            )}
          </ErrorBoundary>
        }
        title="Payoff Calculator"
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
          setData([]);
          reset();
        }}
      />
    </div>
  );
};

const payOffArr = (options, data) => {
  return [
    {
      title: "Loan Number",
      field: "loanrecid",
      type: "select",
      className: "col-6 py-4",
      options: options,
      disable: data?.length ? true : false,
    },
    {
      title: "Payoff Good Through Date",
      field: "payoff_good_through_date",
      type: "date",
      className: "col-6 py-4",
      disable: data?.length ? true : false,
    },
  ];
};

const resultArr = [
  {
    field: "principal_balance",
    title: "Principal Balance",
  },
  {
    field: "accrued_interest",
    title: "Accrued Interest",
  },
  {
    field: "default_interest",
    title: "Default Interest",
  },
  {
    field: "late_charges",
    title: "Late Charges",
  },
  {
    field: "other_fees",
    title: "Other Fees",
  },

  {
    field: "other_payments",
    title: "Other Payments",
  },
  {
    field: "prepayment_penalties",
    title: "Prepayment Penalties",
  },
  {
    field: "trust_balance",
    title: "Trust Balance",
  },
  {
    field: "unpaid_charges",
    title: "Unpaid Charges",
  },
  {
    field: "unpaidinterest",
    title: "Unpaid Interest",
  },
  {
    field: "payoff_amt",
    title: "Payoff Amount",
  },
];
